import type { TestPointRef } from '../types/steps';

/** Returns true if the action string contains the {{nominal}} token. */
export const hasNominalToken = (action: string): boolean =>
  action.includes('{{nominal}}');

/** Resolves {{nominal}} → "300 OHM" using the testPointRef's nominal + functionId. */
export const resolveNominalToken = (
  action: string,
  testPointRef: TestPointRef | null
): string => {
  if (!testPointRef || !hasNominalToken(action)) return action;
  const resolved = testPointRef.functionId
    ? `${testPointRef.nominal} ${testPointRef.functionId.toUpperCase()}`
    : String(testPointRef.nominal);
  return action.replaceAll('{{nominal}}', resolved);
};
